import React from 'react';
import * as styles from './index.module.scss';
import useIsMobile from '../../../hooks/useIsMobile';

export default () => {
  const isMobile = useIsMobile();
  return (
    <div className={styles.featureWrap}>
      <div className={styles.title}>Technical Features</div>
      {isMobile ? (
        <div className={styles.h5Content}>
          <div className={styles.h5Item}>
            <div className={styles.imgs}>
              <img
                src="https://cdn-web.mtt.xyz/static/Frame%201410078408.png"
                alt=""
              />
            </div>
            <div className={styles.content}>
              <div className={styles.title}>Smart Contract Support</div>
              <div className={styles.desc}>
                Supporting EVM smart contracts, providing developers with
                enhanced progranmming flexibility and security.
              </div>
            </div>
          </div>
          <div className={styles.h5Item}>
            <div className={styles.imgs}>
              <img
                src="https://cdn-web.mtt.xyz/static/Frame%201410078393242.png"
                alt=""
              />
            </div>
            <div className={styles.content}>
              <div className={styles.title}>Cross-chain Communication</div>
              <div className={styles.desc}>
                MTT Network can perform cross-chain operations with other block
                chains, enabling seamless transfer of assets and information{' '}
              </div>
            </div>
          </div>
          <div className={styles.h5Item}>
            <div className={styles.imgs}>
              <img
                src="https://cdn-web.mtt.xyz/static/Frame%201410078410.png"
                alt=""
              />
            </div>
            <div className={styles.content}>
              <div className={styles.title}>Modular Design</div>
              <div className={styles.desc}>
                MTT Network can quickly integrate and deploy different
                functional modules, supporting diverse application scenarios.{' '}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.content}>
          <div className={styles.left}>
            <div className={styles.first}>
              <img
                src="https://cdn-web.mtt.xyz/static/Frame%201410078408.png"
                alt=""
              />
              <div className={styles.inner}>
                <div className={styles.label}>Smart Contract Support</div>
                <div>
                  Supporting EVM smart contracts, providing developers with
                  enhanced progranmming flexibility and security.
                </div>
              </div>
            </div>
            <div className={styles.second}>
              <div className={styles.inner}>
                <div className={styles.label}>Cross-chain Communication</div>
                <div>
                  MTT Network can perform cross-chain operations with other
                  block chains, enabling seamless transfer of assets and
                  information
                </div>
              </div>
              <img
                src="https://cdn-web.mtt.xyz/static/Frame%201410078409.png"
                alt=""
              />
            </div>
          </div>
          <div className={styles.right}>
            <img
              src="https://cdn-web.mtt.xyz/static/Frame%201410078410.png"
              alt=""
            />
            <div className={styles.inner}>
              <div className={styles.label}>Modular Design</div>
              <div>
                MTT Network can quickly integrate and deploy different
                functional modules, supporting diverse application scenarios.
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
